$(document).ready(function(){
	console.log('anewall.js');

	$('.search-toggle').click(function(e){
      e.preventDefault();

      preHeader = $('.pre-header'),
      preHeaderSearch = $('.pre-header__search-wrapper');

      preHeaderSearch.toggleClass('open');
      preHeader.toggleClass('search-open');

      $('input[type="search"]').focus();

      $('.anewall_search-bar').toggleClass('isVisible');
      console.log('clicked search again');

  });

  $('.search-bar__close').click(function(e){
      e.preventDefault();
      $('.anewall_search-bar').toggleClass('isVisible');
  });



 
   // var resizeDelay = 100;
   // var doResize = true;
   // var resizer = function () {
   //    if (doResize) {

   //  var materialColWidth = $('.front-page-materials__col').width();
   //  $('.front-page-materials__col .img-wrapper').height( materialColWidth * 1.3 );
   //  $('.front-page-materials__col .front-page-materials__image').height(materialColWidth * 1.6);
   //      doResize = false;
   //    }
   //  };
   //  var resizerInterval = setInterval(resizer, resizeDelay);
   //  resizer();

   //  $(window).resize(function() {
   //    doResize = true;
   //  });




})